import React from 'react';
export function CallToAction() {
  return <div className="bg-red-50 border border-red-200 rounded-lg p-4 sm:p-6 mb-6" data-id="element-199">
      <div className="text-center mb-4" data-id="element-200">
        <div className="inline-block bg-red-600 text-white px-3 py-1 rounded-md mb-3 animate-pulse" data-id="element-201">
          ⚠️ LIMITIERTE VERFÜGBARKEIT - NUR HEUTE ⚠️
        </div>
        <h3 className="font-bold mb-2" data-id="element-202">
          ACHTUNG: Aufgrund der aufwendigen Herstellung mit hochwertigen
          natürlichen ätherischen Ölen können wir nur begrenzte Mengen
          produzieren.
        </h3>
        <div className="mb-4" data-id="element-203">
          <div className="w-full bg-gray-200 rounded-full h-4 mb-2" data-id="element-204">
            <div className="bg-red-600 h-4 rounded-full" style={{
            width: '87%'
          }} data-id="element-205"></div>
          </div>
          <p className="text-sm text-gray-600" data-id="element-206">
            Unsere letzte Produktionscharge ist zu 87% ausverkauft!
          </p>
        </div>
        <p className="font-medium mb-4" data-id="element-207">Aber hier kommt die gute Nachricht:</p>
        <div className="bg-yellow-100 border border-yellow-300 rounded p-3 mb-4" data-id="element-208">
          <p className="font-bold" data-id="element-209">
            Heute bieten wir das komplette NUERA Rauchstopp-Set für 50% weniger
            an als den regulären Preis.
          </p>
        </div>
        <div className="mb-6" data-id="element-210">
          <p className="font-medium mb-2" data-id="element-211">
            PLUS: Als Bonus erhältst du KOSTENLOS Zusatzartikel im Wert von 30€:
          </p>
          <ul className="text-left inline-block" data-id="element-212">
            <li className="flex items-center mb-1" data-id="element-213">
              <span className="mr-2 text-green-500" data-id="element-214">✓</span>
              Gratis Reinigungsset
            </li>
            <li className="flex items-center mb-1" data-id="element-215">
              <span className="mr-2 text-green-500" data-id="element-216">✓</span>
              Gratis Zitronen-Geschmack
            </li>
            <li className="flex items-center mb-1" data-id="element-217">
              <span className="mr-2 text-green-500" data-id="element-218">✓</span>
              Gratis Gewohnheitstracker
            </li>
          </ul>
        </div>
        <p className="text-red-600 font-bold mb-2" data-id="element-219">
          Diese Aktion läuft nur noch heute - danach ist sie für immer weg.
        </p>
        <p className="mb-6" data-id="element-220">
          Sobald die aktuelle Produktionscharge ausverkauft ist, musst du
          mindestens 6-8 Wochen auf die nächste Lieferung warten.
        </p>
      </div>
      <a href="https://mynuera.de/products/nuera-stick" target="_blank" rel="noopener noreferrer" className="block w-full" data-id="element-221">
        <button className="w-full bg-yellow-500 hover:bg-yellow-600 text-black font-bold text-xl py-4 px-6 rounded-lg shadow-xl transition duration-200 mb-3 transform hover:scale-105 border-2 border-yellow-600" data-id="element-222">
          ➤ HIER KLICKEN UND 50% SPAREN - NUR SOLANGE VORRAT REICHT
        </button>
      </a>
      <div className="flex items-center justify-center" data-id="element-223">
        <img src="https://images.unsplash.com/photo-1556741533-6e6a62bd8b49?ixlib=rb-1.2.1&auto=format&fit=crop&w=30&q=80" alt="Secure payment" className="h-6 mr-2" data-id="element-224" />
        <span className="text-sm text-gray-600" data-id="element-225">
          Sichere Bezahlung & schneller Versand
        </span>
      </div>
    </div>;
}